import _ from "lodash";
import { useQuery, useQueries, useMutation } from "react-query";
import { useFetchContext, fetchWithContext } from "../plugins/fetch";

export function useFetchParallel(paths, reactQueryOptions) {
  const fetchContext = useFetchContext();

  return useQueries(
    paths.map((path) => {
      return {
        queryKey: [fetchContext.stack, ...path],
        queryFn: () => fetchWithContext(`/${path.join("/")}`, fetchContext),
        enabled:
          fetchContext.ready && _.get(reactQueryOptions, "enabled", true),
        keepPreviousData: true,
        ...reactQueryOptions,
      };
    })
  );
}

export function useFetch(key, path, reactQueryOptions, defaultResponse) {
  const fetchContext = useFetchContext();

  return useQuery(
    [fetchContext.stack, ...key],
    () => {
      if (path) {
        return fetchWithContext(path, fetchContext);
      } else {
        return Promise.resolve(defaultResponse);
      }
    },
    {
      enabled: fetchContext.ready && _.get(reactQueryOptions, "enabled", true),
      keepPreviousData: true,
      ...reactQueryOptions,
    }
  );
}

export function useFetchForRefetch(
  key,
  path,
  reactQueryOptions,
  defaultResponse
) {
  const fetchContext = useFetchContext();

  const query = useQuery(
    [fetchContext.stack, ...key],
    () => {
      if (path) {
        return fetchWithContext(path, fetchContext);
      } else {
        return Promise.resolve(defaultResponse);
      }
    },
    {
      enabled: fetchContext.ready && _.get(reactQueryOptions, "enabled", true),
      keepPreviousData: true,
      ...reactQueryOptions,
    }
  );

  return {
    ...query,
    refetch: query.refetch,
  };
}

export function useAction(path, method = "post", { onSuccess, onError } = {}) {
  const fetchContext = useFetchContext();

  return useMutation(
    async (mutateParams) => {
      return fetchWithContext(path, fetchContext, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: _.get(mutateParams, "body"),
      });
    },
    {
      onSuccess,

      onError: (err) => {
        // Ensure safe callback call
        if (onError) {
          onError(err);
        } else {
          console.error("Bulk action error:", err);
        }
      },
    }
  );
}
